export default function initVideo() {
  Alpine.data('video', () => ({
    play() {
      const videoId = this.$root.dataset.videoId;
      const videoTitle = this.$root.dataset.videoTitle;
      if (videoId) {
        const iframe = document.createElement('iframe');
        const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&playsinline=1&disablekb=1&modestbranding=1&rel=0`;
        iframe.setAttribute('src', embedUrl);
        if (videoTitle) {
          iframe.setAttribute('title', videoTitle);
        }
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '1');
        iframe.classList.add('w-full', 'h-full');

        this.$refs.videoContainer.appendChild(iframe);
        this.$refs.placeholder.classList.add('hidden');

        const videoContainers = document.querySelectorAll('.video-container');
        videoContainers.forEach(container => {
          if (container !== this.$refs.videoContainer) {
            container.innerHTML = '';
            container.nextElementSibling?.classList.remove('hidden');
          }
        });
      }
    },
  }))
}